import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'
import PartnerVenueTabs from './PartnerVenueTabs'

interface IProps {
  venue_name: string
  slug: string
  guest_list_active: boolean
  active: 'calendar' | 'guest_list'
  month: string // YYYY-MM
  monthPath: string
  summary: React.ReactNode
}

const formatMonthParam = (year: number, monthIndex: number) => {
  // monthIndexは0始まり。年跨ぎはDateが正規化する
  const date = new Date(year, monthIndex, 1)
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
}

const PartnerVenueHeader: React.FC<IProps> = ({
  venue_name,
  slug,
  guest_list_active,
  active,
  month,
  monthPath,
  summary,
}) => {
  const year = Number(month.split('-')[0])
  const monthNumber = Number(month.split('-')[1])

  return (
    <HeaderWrapper>
      <div className="venue">
        <img src="/images/logo_symbol.svg" alt="" width="40" height="40" className="venueLogo" />
        <span className="venueName">
          {venue_name}
          <span>様</span>
        </span>
      </div>
      {guest_list_active && <PartnerVenueTabs active={active} month={month} slug={slug} />}
      <div className="monthNav">
        <div className="monthNavInner">
          <a
            className="navButton"
            href={`${monthPath}?month=${formatMonthParam(year, monthNumber - 2)}`}
          >
            <SvgIcon name="arrow_back" className="icon" ariaHidden={true} role="presentation" />
          </a>
          <span className="currentMonth">
            {year}年<span>{monthNumber}</span>月
          </span>
          <a
            className="navButton"
            href={`${monthPath}?month=${formatMonthParam(year, monthNumber)}`}
          >
            <SvgIcon name="arrow_forward" className="icon" ariaHidden={true} role="presentation" />
          </a>
          <a className="todayButton" href={monthPath}>
            今日
          </a>
        </div>
        <div className="monthTotal">{summary}</div>
      </div>
    </HeaderWrapper>
  )
}

const HeaderWrapper = styled.header`
  flex-shrink: 0;
  border-bottom: 1px solid ${constants.COLORS.divider2};

  .venue {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 56px;
    box-sizing: border-box;
    padding: 8px 64px;
    line-height: 24px;
    border-bottom: 1px solid ${constants.COLORS.divider2};
  }
  .venueLogo {
    position: absolute;
    left: 16px;
    top: 8px;
    object-fit: contain;
    width: 40px;
    height: 40px;
  }
  .venueName {
    overflow: hidden;
    font-size: 15px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-word;
  }
  .venueName span {
    margin-left: 4px;
    font-size: 12px;
    font-weight: normal;
  }

  .monthNav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 12px 16px;
  }
  .monthNavInner {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .navButton,
  .todayButton {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }
  .navButton {
    width: 32px;
    height: 32px;
    border: 1px solid ${constants.COLORS.divider2};
    border-radius: 50%;
    color: ${constants.COLORS.black};
  }
  .navButton .icon {
    width: 20px;
    height: 20px;
  }
  .todayButton {
    margin-left: 4px;
    padding: 4px 8px;
    border: 1px solid ${constants.COLORS.divider2};
    border-radius: 4px;
    color: ${constants.COLORS.primary};
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;
  }
  .currentMonth {
    font-size: 14px;
    white-space: nowrap;
  }
  .currentMonth span,
  .monthTotal strong {
    font-size: 16px;
    font-weight: 600;
  }
  .monthTotal {
    font-size: 12px;
    white-space: nowrap;
  }
  .monthTotal strong {
    margin: 0 4px;
    color: ${constants.COLORS.primary};
  }
  .monthTotal small {
    color: ${constants.COLORS.subText};
  }
  .calendarSummary > span,
  .calendarSummary strong {
    font-size: 14px;
    font-weight: 600;
  }

  @media (min-width: ${constants.BREAKPOINT_TABLET}px) {
    .venueName {
      font-size: 16px;
    }
    .venueName span {
      font-size: 14px;
    }
    .monthNav,
    .monthNavInner {
      gap: 12px;
      padding: 16px;
    }
    .monthNavInner {
      padding: 0;
    }
    .todayButton {
      padding: 4px 12px;
      font-size: 14px;
      line-height: 20px;
    }
    .currentMonth {
      font-size: 16px;
    }
    .currentMonth span,
    .monthTotal strong {
      font-size: 18px;
    }
    .monthTotal {
      font-size: 14px;
    }
    .calendarSummary > span,
    .calendarSummary strong {
      font-size: 16px;
    }
  }
`

export default PartnerVenueHeader
